// extracted by mini-css-extract-plugin
export default {"bonusInputList":"BonusInput_bonusInputList__uF-so"};